/**
 * 引入忽略 mock 的配置文件，此配置只在npm run mock下有效
 *
 * aos:true 代表所有的aos请求会走真实的接口请求
 * aso:['ws/oss/activity/spring_festival/2019/index', '..'] 数组中的接口会走真实的接口请求，其他接口依然走mock
 * 注意：aso的取值仅支持以上两种方式
 *
 * action:true  代表所有的调端的方法都会真实通过jsbridge调用native
 * action:['getAmapUserId', '...'] 代表数组中的action调用会真实调用native，其他action依然会走mock
 * 同样，action的取值仅支持以上两种方式
 */
const ignoreConfig = {
  // aos: ['//sns.testing.amap.com/ws/feedback/orderRevealDetail',
  // '//sns.testing.amap.com/ws/feedback/orderDetail'],
  // 或者数组指定特定接口走真实接口请求 ['请求地址1', '请求地址2']
  aos: false, // 或者数组指定特定接口走真实接口请求 ['请求地址1', '请求地址2']
  action: true, // 或者数组指定特定的action真实调用native ['getAmapUserId', 'getExtraUrl']

};

module.exports = ignoreConfig;
